import { Link, Typography } from "@mui/material";
import { Game, GamePlayer } from "model/Game";
import { useNavigate } from "react-router";

type Props = {
  isOwnPage: boolean
  game: Game
  user: GamePlayer
}
export default function UserInfo(props: Props) {

  const navigate = useNavigate()

  return (
    <>
        {(props.isOwnPage || props.user.open_game_history) &&
          <>
            {props.isOwnPage &&
              <Typography variant='body2'>
                {props.user.name}
              </Typography>
            }
            {!props.isOwnPage &&
              <Link
                variant='body2'
                onClick={() => navigate(`/mypage?id=${props.user.uuid}`)}
                sx={{textDecoration: 'none', cursor: 'pointer'}}
              >
                {props.user.name}
              </Link>
            }
            <Typography variant='body2' color='text.secondary'>
              {props.user.rate}
            </Typography>
            <Typography variant='body2' color={props.user.rate_diff! > 0 ? 'error.dark' : 'primary.dark' }>
              {props.user.rate_diff! > 0 && '+'}{props.user.rate_diff}
            </Typography>
          </>
        }
        {!(props.isOwnPage || props.user.open_game_history) &&
          <>
            <Typography variant='body2' color='text.secondary'>対戦履歴が非公開の</Typography>
            <Typography variant='body2' color='text.secondary'>プレイヤー</Typography>
          </>
        }
    </>
  )
}